<template>
  <!-- 填写物流单号页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="填写物流单号"
        left-arrow
        @click-left="$router.go(-1)"
      />
    </div>
    <div class="center">
      <!-- <h5>请正确填写物流信息，以免影响退款进度</h5> -->
      <img class="Tips" src="../../assets/img/组 8736@2x.png" alt="" />
      <div class="fillInLogistics">
        <!-- <div class="fillInLogisticsTitle">
          <div class="fillInLogisticsTitleText">
            <h6>扫描物流单条形码</h6>
            <p>自动获取物流信息</p>
          </div>
          <img class="scanning" :src="scanning" alt="" />
        </div> -->
        <div class="fillInLogisticsForm">
          <van-form @submit="onSubmit" validate-first>
            <van-cell-group>
              <van-field
                v-model="value1"
                label="物流单号"
                placeholder="请填写物流单号"
                :rules="[{ pattern, message: '请输入正确单号' }]"
              />
              <van-field
                v-model="value2"
                readonly
                label="物流公司"
                right-icon="arrow-down"
                placeholder="请选择物流公司"
                :rules="[{ required: true, message: '请选择物流公司' }]"
                @click-right-icon="showPicker = true"
              />
            </van-cell-group>
            <van-field
              v-model="message"
              rows="2"
              autosize
              label="备注"
              type="textarea"
              maxlength="50"
              placeholder="(选填)如需分多个包裹寄回，请注明其运单信息或联系商家"
              show-word-limit
            />
            <div class="btnBox">
              <van-button round type="info" native-type="onSubmit">
                提交
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="showPicker" title="选择物流公司">
      <ul class="contents">
        <li
          v-for="item in columns"
          :key="item.id"
          @click="saveValue(item)"
          :value="item.selectValue"
        >
          <img :src="item.img" alt="" />{{ item.title }}
        </li>
      </ul>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pattern: /^[A-Za-z0-9]+$/,
      showPicker: false,
      columns: [
        {
          title: "圆通快递",
          img: require("../../assets/img/expressImg/矩形 815@2x.png"),
          selectValue: "YTO",
          id: 3,
        },
        {
          title: "百世快递",
          img: require("../../assets/img/expressImg/矩形 814@2x.png"),
          selectValue: "HTKY",
          id: 4,
        },
        {
          title: "申通快递",
          img: require("../../assets/img/expressImg/矩形 819@2x.png"),
          selectValue: "STO",
          id: 5,
        },
      ],
      message: "",
      value1: "",
      value2: "",
      selectValue: "",
      scanning: require("../../assets/img/NewIcon/组 8697@2x.png"),
    };
  },
  created() {},
  methods: {
    saveValue(value) {
      this.value2 = value.title;
      this.selectValue = value.selectValue;
      this.showPicker = false;
    },
    async onSubmit() {
      let service_id = this.$route.query.service_id;
      await this.$post({
        url: "/saleService/updComeLOGNum",
        method: "post",
        params: {
          expressNo: this.value1,
          expressCompanyCode: this.selectValue,
          service_id,
          logRemark: this.message,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            (this.value1 = ""), (this.value2 = "");
            this.message = "";
            let that = this;
            setTimeout(() => {
              that.$toast("提交成功");
            }, 1000);
            setTimeout(() => {
              that.$router.go(-1);
            }, 1500);
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  height: 100%;
  position: relative;
  background: rgba(245, 245, 245, 1);
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
         font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 500 !important;
      }
    }
  }
  .center {
    background-color: #1f000000;
    padding-top: 1.2rem;
    .Tips {
      padding-top: 0.5rem;
      width: 8.91rem;
      height: 1.74rem;
      display: block;
      margin: 0 auto;
    }
    .fillInLogistics {
      padding: 0.25rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.5rem;
      width: 9rem;
      height: 8.2rem;
      background-color: #fff;
      .fillInLogisticsTitle {
        height: 2rem;
        img {
          float: left;
          width: 1.4rem;
          height: 1.4rem;
        }
        .fillInLogisticsTitleText {
          float: left;
          h6 {
            padding: 0;
            margin: 0;
            color: #333333;
            font-size: 0.37rem;
            margin-left: 0.2rem;
          }
          p {
            margin-top: 0.1rem;
            font-size: 0.32rem;
            color: #333333;
            margin-left: 0.2rem;
          }
        }

        .scanning {
          float: right;
          margin-right: 0.25rem;
          width: 0.56rem;
          height: 0.56rem;
        }
      }
    }
    .btnBox {
      margin-top: 3rem;
      text-align: center;
      .van-button {
        margin-top: 0.5rem;
        width: 8rem;
        height: 1.33rem;
        background-color: #fc563a;
        border-color: #fc563a;
      }
    }
  }
  .contents {
    height: 11rem;
    padding: 0.2rem 0.2rem;
    li {
      height: 1.2rem;
      line-height: 1.2rem;
      text-align: left;
      vertical-align: middle;
      font-size: 0.46rem;
      img {
        vertical-align: middle;
        margin: 0 0.2rem;
        width: 1.84rem;
        height: 0.83rem;
      }
    }
  }
}
</style>
